import { render } from "./AgendamentosEdit.vue?vue&type=template&id=325a0e05"
import script from "./AgendamentosEdit.vue?vue&type=script&lang=js"
export * from "./AgendamentosEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__